import { createActions, createReducer } from 'reduxsauce'

import ArquivosAdvertenciaFornecedorService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosAdvertenciaFornecedorInicio: [],
    buscaArquivosAdvertenciaFornecedorSucesso: ['arquivosAdvertenciaFornecedor'],
    buscaArquivosAdvertenciaFornecedorErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosAdvertenciaFornecedor = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosAdvertenciaFornecedorInicio())
        let serv = new ArquivosAdvertenciaFornecedorService()
        return serv
            .consultarAnexosDetalhesAdvertenciaFornecedor(filtro)
            .then(response => dispatch(Creators.buscaArquivosAdvertenciaFornecedorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosAdvertenciaFornecedorErro(error)))
    }
}

const buscaArquivosAdvertenciaFornecedorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaArquivosAdvertenciaFornecedorErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosAdvertenciaFornecedorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosAdvertenciaFornecedor, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_ADVERTENCIA_FORNECEDOR_INICIO]: buscaArquivosAdvertenciaFornecedorInicio,
    [Types.BUSCA_ARQUIVOS_ADVERTENCIA_FORNECEDOR_ERRO]: buscaArquivosAdvertenciaFornecedorErro,
    [Types.BUSCA_ARQUIVOS_ADVERTENCIA_FORNECEDOR_SUCESSO]: buscaArquivosAdvertenciaFornecedorSucesso,
})
